import TransactionHistory from './TransactionHistory.js';

export default TransactionHistory;
